"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quiz/quiz-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquiz%2Fquiz-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizServiceClient = exports.GetQuizLeaderboardParticipationResponse = exports.GetQuizLeaderboardParticipationRequest = exports.GetQuizLeaderboardAvatarResponse = exports.GetQuizLeaderboardAvatarRequest = exports.GetQuizLeaderboardStatsResponse = exports.GetQuizLeaderboardStatsRequest = exports.GetQuizLeaderboardsResponse = exports.GetQuizLeaderboardsRequest = exports.GetQuizLeaderboardResponse = exports.GetQuizLeaderboardRequest = exports.UpdateUserSettingsResponse = exports.UserSettings = exports.UpdateUserSettingsRequest = exports.GetUserSettingsResponse = exports.GetUserSettingsRequest = exports.GetQuizStatsResponse = exports.GetQuizStatsRequest = exports.RecordUserChoiceResponse = exports.RecordUserChoiceRequest = exports.GetQuizResponse = exports.GetQuizRequest = exports.Quiz = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const paging_1 = require("../paging/paging");
const question_1 = require("./question");
const quiz_leaderboard_1 = require("./quiz-leaderboard");
const quiz_stats_1 = require("./quiz-stats");
const quiz_type_1 = require("./quiz-type");
const protobufPackage = 'com.step.quiz.proto';
function createBaseQuiz() {
    return { quizId: '', questions: [], userChoices: [], passMessage: '', failMessage: '' };
}
exports.Quiz = {
    fromJSON(object) {
        const message = {
            quizId: isSet(object.quizId) ? globalThis.String(object.quizId) : '',
            questions: globalThis.Array.isArray(object?.questions)
                ? object.questions.map((e) => question_1.Question.fromJSON(e))
                : [],
            userChoices: globalThis.Array.isArray(object?.userChoices)
                ? object.userChoices.map((e) => question_1.UserChoice.fromJSON(e))
                : [],
        };
        if (isSet(object.passMessage)) {
            message.passMessage = globalThis.String(object.passMessage);
        }
        if (isSet(object.failMessage)) {
            message.failMessage = globalThis.String(object.failMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizId !== '') {
            obj.quizId = message.quizId;
        }
        if (message.questions?.length) {
            obj.questions = message.questions.map((e) => question_1.Question.toJSON(e));
        }
        if (message.userChoices?.length) {
            obj.userChoices = message.userChoices.map((e) => question_1.UserChoice.toJSON(e));
        }
        if (message.passMessage !== undefined && message.passMessage !== '') {
            obj.passMessage = message.passMessage;
        }
        if (message.failMessage !== undefined && message.failMessage !== '') {
            obj.failMessage = message.failMessage;
        }
        return obj;
    },
    create(base) {
        return exports.Quiz.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuiz();
        message.quizId = object.quizId ?? '';
        message.questions = object.questions?.map((e) => question_1.Question.fromPartial(e)) || [];
        message.userChoices = object.userChoices?.map((e) => question_1.UserChoice.fromPartial(e)) || [];
        message.passMessage = object.passMessage ?? '';
        message.failMessage = object.failMessage ?? '';
        return message;
    },
};
function createBaseGetQuizRequest() {
    return { quizType: quiz_type_1.QuizType.INVALID_QUIZ_TYPE };
}
exports.GetQuizRequest = {
    fromJSON(object) {
        const message = {
            quizType: isSet(object.quizType)
                ? (0, quiz_type_1.quizTypeFromJSON)(object.quizType)
                : quiz_type_1.QuizType.INVALID_QUIZ_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizType !== quiz_type_1.QuizType.INVALID_QUIZ_TYPE) {
            obj.quizType = (0, quiz_type_1.quizTypeToJSON)(message.quizType);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizRequest();
        message.quizType = object.quizType ?? quiz_type_1.QuizType.INVALID_QUIZ_TYPE;
        return message;
    },
};
function createBaseGetQuizResponse() {
    return { quiz: undefined };
}
exports.GetQuizResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.quiz)) {
            message.quiz = exports.Quiz.fromJSON(object.quiz);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quiz !== undefined) {
            obj.quiz = exports.Quiz.toJSON(message.quiz);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizResponse();
        message.quiz = (object.quiz !== undefined && object.quiz !== null)
            ? exports.Quiz.fromPartial(object.quiz)
            : undefined;
        return message;
    },
};
function createBaseRecordUserChoiceRequest() {
    return { quizId: '', questionId: '', choiceId: '', timingMs: '0' };
}
exports.RecordUserChoiceRequest = {
    fromJSON(object) {
        const message = {
            quizId: isSet(object.quizId) ? globalThis.String(object.quizId) : '',
            questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : '',
            choiceId: isSet(object.choiceId) ? globalThis.String(object.choiceId) : '',
            timingMs: isSet(object.timingMs) ? globalThis.String(object.timingMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizId !== '') {
            obj.quizId = message.quizId;
        }
        if (message.questionId !== '') {
            obj.questionId = message.questionId;
        }
        if (message.choiceId !== '') {
            obj.choiceId = message.choiceId;
        }
        if (message.timingMs !== '0') {
            obj.timingMs = message.timingMs;
        }
        return obj;
    },
    create(base) {
        return exports.RecordUserChoiceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordUserChoiceRequest();
        message.quizId = object.quizId ?? '';
        message.questionId = object.questionId ?? '';
        message.choiceId = object.choiceId ?? '';
        message.timingMs = object.timingMs ?? '0';
        return message;
    },
};
function createBaseRecordUserChoiceResponse() {
    return { score: quiz_leaderboard_1.UserChoiceScore.fromPartial({}) };
}
exports.RecordUserChoiceResponse = {
    fromJSON(object) {
        const message = {
            score: isSet(object.score)
                ? quiz_leaderboard_1.UserChoiceScore.fromJSON(object.score)
                : quiz_leaderboard_1.UserChoiceScore.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.score !== undefined) {
            obj.score = quiz_leaderboard_1.UserChoiceScore.toJSON(message.score);
        }
        return obj;
    },
    create(base) {
        return exports.RecordUserChoiceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordUserChoiceResponse();
        message.score = (object.score !== undefined && object.score !== null)
            ? quiz_leaderboard_1.UserChoiceScore.fromPartial(object.score)
            : quiz_leaderboard_1.UserChoiceScore.fromPartial({});
        return message;
    },
};
function createBaseGetQuizStatsRequest() {
    return { quizType: quiz_type_1.QuizType.INVALID_QUIZ_TYPE };
}
exports.GetQuizStatsRequest = {
    fromJSON(object) {
        const message = {
            quizType: isSet(object.quizType)
                ? (0, quiz_type_1.quizTypeFromJSON)(object.quizType)
                : quiz_type_1.QuizType.INVALID_QUIZ_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizType !== quiz_type_1.QuizType.INVALID_QUIZ_TYPE) {
            obj.quizType = (0, quiz_type_1.quizTypeToJSON)(message.quizType);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizStatsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizStatsRequest();
        message.quizType = object.quizType ?? quiz_type_1.QuizType.INVALID_QUIZ_TYPE;
        return message;
    },
};
function createBaseGetQuizStatsResponse() {
    return {
        quizStats: undefined,
        quizLeaderboardStats: undefined,
        totalScore: '0',
        answeredThisWeek: 0,
    };
}
exports.GetQuizStatsResponse = {
    fromJSON(object) {
        const message = {
            totalScore: isSet(object.totalScore) ? globalThis.String(object.totalScore) : '0',
            answeredThisWeek: isSet(object.answeredThisWeek)
                ? globalThis.Number(object.answeredThisWeek)
                : 0,
        };
        if (isSet(object.quizStats)) {
            message.quizStats = quiz_stats_1.QuizStats.fromJSON(object.quizStats);
        }
        if (isSet(object.quizLeaderboardStats)) {
            message.quizLeaderboardStats = quiz_leaderboard_1.QuizLeaderboardStats.fromJSON(object.quizLeaderboardStats);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizStats !== undefined) {
            obj.quizStats = quiz_stats_1.QuizStats.toJSON(message.quizStats);
        }
        if (message.quizLeaderboardStats !== undefined) {
            obj.quizLeaderboardStats = quiz_leaderboard_1.QuizLeaderboardStats.toJSON(message.quizLeaderboardStats);
        }
        if (message.totalScore !== '0') {
            obj.totalScore = message.totalScore;
        }
        if (message.answeredThisWeek !== 0) {
            obj.answeredThisWeek = Math.round(message.answeredThisWeek);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizStatsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizStatsResponse();
        message.quizStats = (object.quizStats !== undefined && object.quizStats !== null)
            ? quiz_stats_1.QuizStats.fromPartial(object.quizStats)
            : undefined;
        message.quizLeaderboardStats =
            (object.quizLeaderboardStats !== undefined && object.quizLeaderboardStats !== null)
                ? quiz_leaderboard_1.QuizLeaderboardStats.fromPartial(object.quizLeaderboardStats)
                : undefined;
        message.totalScore = object.totalScore ?? '0';
        message.answeredThisWeek = object.answeredThisWeek ?? 0;
        return message;
    },
};
function createBaseGetUserSettingsRequest() {
    return { leaderboardId: undefined };
}
exports.GetUserSettingsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.leaderboardId)) {
            message.leaderboardId = globalThis.String(object.leaderboardId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.leaderboardId !== undefined) {
            obj.leaderboardId = message.leaderboardId;
        }
        return obj;
    },
    create(base) {
        return exports.GetUserSettingsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserSettingsRequest();
        message.leaderboardId = object.leaderboardId ?? undefined;
        return message;
    },
};
function createBaseGetUserSettingsResponse() {
    return { userSettings: exports.UserSettings.fromPartial({}) };
}
exports.GetUserSettingsResponse = {
    fromJSON(object) {
        const message = {
            userSettings: isSet(object.userSettings)
                ? exports.UserSettings.fromJSON(object.userSettings)
                : exports.UserSettings.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userSettings !== undefined) {
            obj.userSettings = exports.UserSettings.toJSON(message.userSettings);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserSettingsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserSettingsResponse();
        message.userSettings = (object.userSettings !== undefined && object.userSettings !== null)
            ? exports.UserSettings.fromPartial(object.userSettings)
            : exports.UserSettings.fromPartial({});
        return message;
    },
};
function createBaseUpdateUserSettingsRequest() {
    return { leaderboardId: undefined, userSettings: exports.UserSettings.fromPartial({}) };
}
exports.UpdateUserSettingsRequest = {
    fromJSON(object) {
        const message = {
            userSettings: isSet(object.userSettings)
                ? exports.UserSettings.fromJSON(object.userSettings)
                : exports.UserSettings.fromPartial({}),
        };
        if (isSet(object.leaderboardId)) {
            message.leaderboardId = globalThis.String(object.leaderboardId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.leaderboardId !== undefined) {
            obj.leaderboardId = message.leaderboardId;
        }
        if (message.userSettings !== undefined) {
            obj.userSettings = exports.UserSettings.toJSON(message.userSettings);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateUserSettingsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateUserSettingsRequest();
        message.leaderboardId = object.leaderboardId ?? undefined;
        message.userSettings = (object.userSettings !== undefined && object.userSettings !== null)
            ? exports.UserSettings.fromPartial(object.userSettings)
            : exports.UserSettings.fromPartial({});
        return message;
    },
};
function createBaseUserSettings() {
    return { isParticipating: false, avatarUrl: '', userName: '' };
}
exports.UserSettings = {
    fromJSON(object) {
        const message = {
            isParticipating: isSet(object.isParticipating)
                ? globalThis.Boolean(object.isParticipating)
                : false,
            avatarUrl: isSet(object.avatarUrl) ? globalThis.String(object.avatarUrl) : '',
        };
        if (isSet(object.userName)) {
            message.userName = globalThis.String(object.userName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isParticipating !== false) {
            obj.isParticipating = message.isParticipating;
        }
        if (message.avatarUrl !== '') {
            obj.avatarUrl = message.avatarUrl;
        }
        if (message.userName !== undefined && message.userName !== '') {
            obj.userName = message.userName;
        }
        return obj;
    },
    create(base) {
        return exports.UserSettings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSettings();
        message.isParticipating = object.isParticipating ?? false;
        message.avatarUrl = object.avatarUrl ?? '';
        message.userName = object.userName ?? '';
        return message;
    },
};
function createBaseUpdateUserSettingsResponse() {
    return {};
}
exports.UpdateUserSettingsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateUserSettingsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateUserSettingsResponse();
        return message;
    },
};
function createBaseGetQuizLeaderboardRequest() {
    return { quizType: quiz_type_1.QuizType.INVALID_QUIZ_TYPE, leaderboardId: undefined };
}
exports.GetQuizLeaderboardRequest = {
    fromJSON(object) {
        const message = {
            quizType: isSet(object.quizType)
                ? (0, quiz_type_1.quizTypeFromJSON)(object.quizType)
                : quiz_type_1.QuizType.INVALID_QUIZ_TYPE,
        };
        if (isSet(object.leaderboardId)) {
            message.leaderboardId = globalThis.String(object.leaderboardId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizType !== quiz_type_1.QuizType.INVALID_QUIZ_TYPE) {
            obj.quizType = (0, quiz_type_1.quizTypeToJSON)(message.quizType);
        }
        if (message.leaderboardId !== undefined) {
            obj.leaderboardId = message.leaderboardId;
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardRequest();
        message.quizType = object.quizType ?? quiz_type_1.QuizType.INVALID_QUIZ_TYPE;
        message.leaderboardId = object.leaderboardId ?? undefined;
        return message;
    },
};
function createBaseGetQuizLeaderboardResponse() {
    return { leaderboard: quiz_leaderboard_1.QuizLeaderboard.fromPartial({}) };
}
exports.GetQuizLeaderboardResponse = {
    fromJSON(object) {
        const message = {
            leaderboard: isSet(object.leaderboard)
                ? quiz_leaderboard_1.QuizLeaderboard.fromJSON(object.leaderboard)
                : quiz_leaderboard_1.QuizLeaderboard.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.leaderboard !== undefined) {
            obj.leaderboard = quiz_leaderboard_1.QuizLeaderboard.toJSON(message.leaderboard);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardResponse();
        message.leaderboard = (object.leaderboard !== undefined && object.leaderboard !== null)
            ? quiz_leaderboard_1.QuizLeaderboard.fromPartial(object.leaderboard)
            : quiz_leaderboard_1.QuizLeaderboard.fromPartial({});
        return message;
    },
};
function createBaseGetQuizLeaderboardsRequest() {
    return { quizType: quiz_type_1.QuizType.INVALID_QUIZ_TYPE, paging: undefined };
}
exports.GetQuizLeaderboardsRequest = {
    fromJSON(object) {
        const message = {
            quizType: isSet(object.quizType)
                ? (0, quiz_type_1.quizTypeFromJSON)(object.quizType)
                : quiz_type_1.QuizType.INVALID_QUIZ_TYPE,
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizType !== quiz_type_1.QuizType.INVALID_QUIZ_TYPE) {
            obj.quizType = (0, quiz_type_1.quizTypeToJSON)(message.quizType);
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardsRequest();
        message.quizType = object.quizType ?? quiz_type_1.QuizType.INVALID_QUIZ_TYPE;
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetQuizLeaderboardsResponse() {
    return { leaderboardInfos: [], paging: undefined };
}
exports.GetQuizLeaderboardsResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.leaderboardInfos)) {
            message.leaderboardInfos = object.leaderboardInfos.map((e) => quiz_leaderboard_1.LeaderboardInfo.fromJSON(e));
        }
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.leaderboardInfos?.length) {
            obj.leaderboardInfos = message.leaderboardInfos.map((e) => quiz_leaderboard_1.LeaderboardInfo.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardsResponse();
        message.leaderboardInfos =
            object.leaderboardInfos?.map((e) => quiz_leaderboard_1.LeaderboardInfo.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetQuizLeaderboardStatsRequest() {
    return { id: '' };
}
exports.GetQuizLeaderboardStatsRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardStatsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardStatsRequest();
        message.id = object.id ?? '';
        return message;
    },
};
function createBaseGetQuizLeaderboardStatsResponse() {
    return { quizLeaderboardStats: quiz_leaderboard_1.QuizLeaderboardStats.fromPartial({}) };
}
exports.GetQuizLeaderboardStatsResponse = {
    fromJSON(object) {
        const message = {
            quizLeaderboardStats: isSet(object.quizLeaderboardStats)
                ? quiz_leaderboard_1.QuizLeaderboardStats.fromJSON(object.quizLeaderboardStats)
                : quiz_leaderboard_1.QuizLeaderboardStats.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizLeaderboardStats !== undefined) {
            obj.quizLeaderboardStats = quiz_leaderboard_1.QuizLeaderboardStats.toJSON(message.quizLeaderboardStats);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardStatsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardStatsResponse();
        message.quizLeaderboardStats =
            (object.quizLeaderboardStats !== undefined && object.quizLeaderboardStats !== null)
                ? quiz_leaderboard_1.QuizLeaderboardStats.fromPartial(object.quizLeaderboardStats)
                : quiz_leaderboard_1.QuizLeaderboardStats.fromPartial({});
        return message;
    },
};
function createBaseGetQuizLeaderboardAvatarRequest() {
    return {};
}
exports.GetQuizLeaderboardAvatarRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardAvatarRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetQuizLeaderboardAvatarRequest();
        return message;
    },
};
function createBaseGetQuizLeaderboardAvatarResponse() {
    return { avatarUrl: '' };
}
exports.GetQuizLeaderboardAvatarResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.avatarUrl)) {
            message.avatarUrl = globalThis.String(object.avatarUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.avatarUrl !== undefined && message.avatarUrl !== '') {
            obj.avatarUrl = message.avatarUrl;
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardAvatarResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardAvatarResponse();
        message.avatarUrl = object.avatarUrl ?? '';
        return message;
    },
};
function createBaseGetQuizLeaderboardParticipationRequest() {
    return { quizType: quiz_type_1.QuizType.INVALID_QUIZ_TYPE };
}
exports.GetQuizLeaderboardParticipationRequest = {
    fromJSON(object) {
        const message = {
            quizType: isSet(object.quizType)
                ? (0, quiz_type_1.quizTypeFromJSON)(object.quizType)
                : quiz_type_1.QuizType.INVALID_QUIZ_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quizType !== quiz_type_1.QuizType.INVALID_QUIZ_TYPE) {
            obj.quizType = (0, quiz_type_1.quizTypeToJSON)(message.quizType);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardParticipationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardParticipationRequest();
        message.quizType = object.quizType ?? quiz_type_1.QuizType.INVALID_QUIZ_TYPE;
        return message;
    },
};
function createBaseGetQuizLeaderboardParticipationResponse() {
    return { isParticipating: false };
}
exports.GetQuizLeaderboardParticipationResponse = {
    fromJSON(object) {
        const message = {
            isParticipating: isSet(object.isParticipating)
                ? globalThis.Boolean(object.isParticipating)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isParticipating !== false) {
            obj.isParticipating = message.isParticipating;
        }
        return obj;
    },
    create(base) {
        return exports.GetQuizLeaderboardParticipationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuizLeaderboardParticipationResponse();
        message.isParticipating = object.isParticipating ?? false;
        return message;
    },
};
/**
 * Service API for Quiz service.
 */
class QuizServiceClient {
    rpc;
    name = 'com.step.quiz.proto.QuizService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/quiz';
    methods = [{
            name: 'GetQuiz',
            requestType: exports.GetQuizRequest,
            responseType: exports.GetQuizResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RecordUserChoice',
            requestType: exports.RecordUserChoiceRequest,
            responseType: exports.RecordUserChoiceResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizStats',
            requestType: exports.GetQuizStatsRequest,
            responseType: exports.GetQuizStatsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetUserSettings',
            requestType: exports.GetUserSettingsRequest,
            responseType: exports.GetUserSettingsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateUserSettings',
            requestType: exports.UpdateUserSettingsRequest,
            responseType: exports.UpdateUserSettingsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizLeaderboard',
            requestType: exports.GetQuizLeaderboardRequest,
            responseType: exports.GetQuizLeaderboardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizLeaderboardAvatar',
            requestType: exports.GetQuizLeaderboardAvatarRequest,
            responseType: exports.GetQuizLeaderboardAvatarResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizLeaderboardParticipation',
            requestType: exports.GetQuizLeaderboardParticipationRequest,
            responseType: exports.GetQuizLeaderboardParticipationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizLeaderboards',
            requestType: exports.GetQuizLeaderboardsRequest,
            responseType: exports.GetQuizLeaderboardsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuizLeaderboardStats',
            requestType: exports.GetQuizLeaderboardStatsRequest,
            responseType: exports.GetQuizLeaderboardStatsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get a quiz by id.
     */
    getQuiz(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Record an answer for a question.
     */
    recordUserChoice(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get stats for a quiz type.
     */
    getQuizStats(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get user settings
     */
    getUserSettings(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update user settings
     */
    updateUserSettings(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get the leaderboard for a quiz type.
     */
    getQuizLeaderboard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * DEPRECATED - REMOVE
     * Get leaderboard avatar for a user.
     */
    getQuizLeaderboardAvatar(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get leaderboard participation for a user.
     */
    getQuizLeaderboardParticipation(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a paginated list of leaderboard details for a quiz type.
     */
    getQuizLeaderboards(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get leaderboard stats.
     */
    getQuizLeaderboardStats(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.QuizServiceClient = QuizServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=quiz-service.js.map